<template>
  <div class="brand">
    <div class="news">
      <!-- 新闻详情 -->
      <div class="news-content">
        <div class="news-content-cover">
          <img :src="content.avatar" :alt="content.title" />
        </div>
        <h2 class="news-content-title">{{ content.title }}</h2>
        <p class="news-content-date">发布时间 : {{ content.created }}</p>
        <p class="news-content-desc">{{ content.summary }}</p>
        <div class="news-content-main" v-html="content.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
const tabs = [
  { label: "企业新闻", value: "corporate" },
  { label: "展览新闻", value: "exhibition" },
  { label: "行业新闻", value: "industry" }
];

export default {
  name: "brand",
  components: {},
  data() {
    return {
      tabs,
      content: {}
    };
  },
  created() {
    this.getNews();
  },

  methods: {
    getNews() {
      this.$api.brand.getBrand(this.$route.params.id).then(res => {
        this.content = res.result;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.brand {
  background: #f3f3f3;
}
.news {
  width: 72%;
  margin: 0 auto;
  padding: 30px;
  &-list {
    .new {
      margin: 30px 0;
      background: white;
      .text-warp {
        padding: 2rem 1rem 1rem;
        p {
          margin-bottom: 0;
          overflow: hidden;
          -o-text-overflow: ellipsis;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          height: 3rem;
          line-height: 1.5rem;
        }
      }
      .new-title {
        display: flex;
        font-size: 1.2rem;
        justify-content: space-between;
        align-items: baseline;
        flex-wrap: wrap;
        flex-direction: column;
        > p {
          margin-bottom: 0.5rem;
          height: 4rem;
          line-height: 2rem;
        }
      }
      &-date {
        font-size: 14px;
        color: #828282;
      }
      &:hover {
        cursor: pointer;
        box-shadow: 1px 6px 10px -4px;
      }
    }
  }
}
.image-container {
  width: 100%;
  height: 0;
  padding-bottom: 60%;
  overflow: hidden;
  img {
    width: 100%;
  }
}
.image-container::before {
  content: "";
  padding-top: 100%;
  float: left;
}
.image-container::after {
  content: "";
  display: block;
  clear: both;
}
.news-content {
  img {
    width: 100%;
  }
  &-title {
    text-align: center;
    margin: 2rem 0 1rem;
  }
  &-date {
    font-size: 14px;
    text-align: center;
    color: #bbb;
    margin-bottom: 2rem;
  }
  &-desc {
    padding: 1rem;
    background: #ececec;
    color: #707070;
  }
}
@include media-breakpoint-down(lg) {
  .news {
    padding: 2rem 1rem;
    margin: auto;
    width: 100%;
  }
}
</style>
